import { IssueTaskCategory, IssueTaskDoc, IssueTaskStatus } from '@gooduncles/gu-app-schema';

/**
 * 재고 입고 관리 테이블의 Row 데이터 타입
 * - IssueTask의 inventoryIssueInfo.products를 기준으로 평탄화된 구조
 * - 각 row는 하나의 상품을 나타냄
 */
export interface InventoryIssueRow {
  /** Row 고유 ID (taskId + productId) */
  rowId: string;

  // IssueTask 기본 정보
  /** Task ID */
  taskId: string;
  /** Issue Case ID */
  issueCaseId: string;
  /** Task 카테고리 */
  category: IssueTaskCategory;
  /** Task 상태 */
  taskStatus: IssueTaskStatus;
  /** 매장 ID */
  storeId: string;
  /** 매장명 */
  storeName: string;
  /** Task 등록 시각 */
  registeredAt: string;
  /** 처리 목표 일자 */
  targetDate: string | null;
  /** Task 완료 시각 */
  finishedAt: string | null;
  /** 원본 케이스 발생 원천 기준일 */
  caseSourceReferenceDate: string | null;

  // 상품 정보 (IssueTask.products에서)
  /** 상품 ID */
  productId: string;
  /** 상품명 */
  productName: string;
  /** 재고 ID */
  inventoryId: string;
  /** 수량 */
  quantity: number;
  /** 판매가 */
  price: number;

  // inventoryIssueInfo에서
  /**
   * 재고 처리 상태
   * - pending: 미결정
   * - completed: 입고 완료
   * - skipped: 폐기 처리
   * - failed: 실패
   */
  inventoryStatus: 'pending' | 'completed' | 'skipped' | 'failed';
  /** 재고 이슈 ID (completed 상태일 때만 존재) */
  inventoryIssueId: string | null;
  /** 재고 처리 시각 */
  processedAt: string | null;

  /** 원본 IssueTaskDoc (상세 보기 등에 활용) */
  _originalTask: IssueTaskDoc;
}

/**
 * 재고 처리 상태별 뱃지 매핑 정보
 */
export interface InventoryStatusBadgeInfo {
  text: string;
  color: string;
}

export const inventoryStatusBadgeMap: Record<InventoryIssueRow['inventoryStatus'], InventoryStatusBadgeInfo> = {
  pending: { text: '대기', color: 'default' },
  completed: { text: '입고완료', color: 'success' },
  skipped: { text: '폐기', color: 'warning' },
  failed: { text: '실패', color: 'error' },
};
